"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var flatlist_react_1 = __importDefault(require("./flatlist-react"));
exports.default = flatlist_react_1.default;
//# sourceMappingURL=index.js.map